import { IChildrenProp } from 'types/components/components.interface';
import './FlexWrapper.scss';

interface IFlexWrapperProps extends IChildrenProp {}

const FlexWrapper = ({ children }: IFlexWrapperProps) => {
  return <div className='flex-wrapper'>{children}</div>;
};

export default FlexWrapper;
